import {
   NationalIdentificationNumber,
   NationalIdentificationNumberCountry,
} from '@dreryk/personal-external-identifier-common-api';

import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { patientTranslationKeys, personalDataTranslationKeys } from '../../../../translations';

import { StyledNationalIdentificationNumberField } from './NationalIdentificationNumberField.styled';

type NationalIdentificationNumberFormBeanPart = {
   nationalIdentificationNumber?: string | null;
   nationalIdentificationNumberCountry?: NationalIdentificationNumberCountry | null;
};
type NationalIdentificationNumberFieldProps = Pick<
   FormContextValues<NationalIdentificationNumberFormBeanPart>,
   'register'
>;

export const NationalIdentificationNumberField = (props: NationalIdentificationNumberFieldProps): JSX.Element => {
   return (
      <StyledNationalIdentificationNumberField>
         <TextInput
            controller={props.register('nationalIdentificationNumber', {
               required: true,
               maxLength: NationalIdentificationNumber.MAX_LENGTH,
               pattern: {
                  value: new RegExp(NationalIdentificationNumber.PATTERN, 'u'),
                  message: patientTranslationKeys.invalidNationalIdentificationNumberPattern,
               },
               validate: (value) =>
                  NationalIdentificationNumber.isValueValid(value as string)
                     ? undefined
                     : patientTranslationKeys.invalidNationalIdentificationNumber,
            })}
            label={patientTranslationKeys.personalIdentifier}
            placeholder={personalDataTranslationKeys.identifierType.displayName.NationalIdentificationNumber}
            testId={'nationalIdentificationNumber'}
            defaultValue={null}
         />
      </StyledNationalIdentificationNumberField>
   );
};
